import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'

import { PAGINATION } from '../../common/constants'
import { apolloService } from '../../common/services'

import { DELETE_DICTIONARY_WORD_MUTATION } from '../graphql/mutations'
import { DELETE_DICTIONARY_WORD } from '../redux/action-types'

const useDeleteDictionaryWordMutation = (type, refetchLastEvent) => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store =>
    get(store.dictionaryWords.data, type.fieldName, {}),
  )

  const mutate = useCallback(
    async (id, filters, page, pageSize) => {
      await apolloService.mutate(
        DELETE_DICTIONARY_WORD_MUTATION,
        {
          id,
          filters: { ...filters, type: type.value },
          page: page || PAGINATION.DEFAULT_PAGE,
          pageSize: pageSize || PAGINATION.DEFAULT_PAGE_SIZE,
        },
        dispatch,
        DELETE_DICTIONARY_WORD,
      )

      refetchLastEvent()
    },
    [dispatch, type, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteDictionaryWordMutation
